import { STATUSES } from '@/constants/common/message.constants'

import { type TruckClassImportJobExEntity } from '../../aspida/@types'

/**
 * 車格取込ステータス
 */
export type TruckClassImportJobStatusType =
  TruckClassImportJobExEntity['status']

export const TRUCK_CLASS_IMPORT_JOB_STATUS_TYPE = {
  /** 取込待ち */
  PENDING: 'PENDING',
  /** 取込中 */
  IMPORTING: 'IMPORTING',
  /** 完了 */
  COMPLETED: 'COMPLETED',
  /** エラー */
  ERROR: 'ERROR'
} as const satisfies Record<
  TruckClassImportJobStatusType,
  TruckClassImportJobStatusType
>

export const TRUCK_CLASS_IMPORT_JOB_STATUS_TYPE_LABEL = {
  [TRUCK_CLASS_IMPORT_JOB_STATUS_TYPE.PENDING]: STATUSES.PENDING,
  [TRUCK_CLASS_IMPORT_JOB_STATUS_TYPE.IMPORTING]: STATUSES.PROCESSING,
  [TRUCK_CLASS_IMPORT_JOB_STATUS_TYPE.COMPLETED]: STATUSES.COMPLETED,
  [TRUCK_CLASS_IMPORT_JOB_STATUS_TYPE.ERROR]: STATUSES.FAILED
} as const satisfies Record<TruckClassImportJobStatusType, string>
